import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const Fund = Loadable(lazy(() => import('views/fund')));
const User = Loadable(lazy(() => import('views/user')));
const Loan = Loadable(lazy(() => import('views/loan')));
const Payment = Loadable(lazy(() => import('views/payment')));
const Tel = Loadable(lazy(() => import('views/contact/tel')));
const Social = Loadable(lazy(() => import('views/contact/social')));
const About = Loadable(lazy(() => import('views/features/about')));
const Terms = Loadable(lazy(() => import('views/features/terms')));
const Share = Loadable(lazy(() => import('views/features/share')));
const Rate = Loadable(lazy(() => import('views/features/rate')));
const Faq = Loadable(lazy(() => import('views/features/faq')));
const Wallet = Loadable(lazy(() => import('views/wallet')));
const Account = Loadable(lazy(() => import('views/account')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: '*',
            element: <DashboardDefault />
        },
        {
            path: '/dashboard',
            element: <DashboardDefault />
        },
        {
            path: '/fund/:fundId',
            element: <Fund />
        },
        {
            path: '/fund/:fundId/user/:userId',
            element: <User />
        },
        {
            path: '/loan/:loanId',
            element: <Loan />
        },
        {
            path: '/payment/:paymentId',
            element: <Payment />
        },
        {
            path: '/social',
            element: <Social />
        },
        {
            path: '/tel',
            element: <Tel />
        },
        {
            path: '/about',
            element: <About />
        },
        {
            path: '/terms',
            element: <Terms />
        },
        {
            path: '/share',
            element: <Share />
        },
        {
            path: '/rate',
            element: <Rate />
        },
        {
            path: '/faq',
            element: <Faq />
        },
        {
            path: '/wallet',
            element: <Wallet />
        },
        {
            path: '/account',
            element: <Account />
        }
    ]
};

export default MainRoutes;
